import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    infoText: string;
    learnMore: string;
    cancel: string;
    iAgree: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Dialog title */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateConsentDialog.title?c=112tec5701250", defaultMessage: "About Translating Video" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Info text explaining consent requirements */
            infoText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateConsentDialog.infoText?c=125qx850a1ai6", defaultMessage: "This feature analyzes voices and faces to enable translations. By using it, you confirm all individuals consent. Adobe will not use your content to train AI." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for learn more link */
            learnMore: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateConsentDialog.learnMore?c=h8sd9u7vqbji", defaultMessage: "Learn More" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Cancel button label */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateConsentDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Agree button label */
            iAgree: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FireflyTranslateConsentDialog.iAgree?c=oqre76vwq1am", defaultMessage: "I Agree" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
